import React from 'react'

import { Icon } from '@types'

const NotionIcon: Icon = ({ fill = 'white' }) => (
  <svg
    width='16'
    height='14'
    viewBox='0 0 16 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.9,2.455c.454.353.624.327,1.477.272l8.036-.463c.17,0,.029-.163-.028-.19l-1.335-.926A1.651,1.651,0,0,0,9.8.794l-7.781.545c-.283.027-.341.163-.227.272Zm.482,1.8v8.111c0,.436.227.6.738.572l8.832-.49c.511-.027.569-.327.569-.681V3.707c0-.353-.142-.544-.455-.517L3.84,3.707c-.341.027-.454.191-.454.544Zm8.719.435c.057.245,0,.49-.255.518l-.426.082v5.987a2.285,2.285,0,0,1-.994.3c-.455,0-.569-.136-.909-.544L6.736,6.837v4.055l.881.191s0,.49-.71.49l-1.959.109a.345.345,0,0,1,.2-.435l.511-.136V5.748l-.708-.055a.512.512,0,0,1,.482-.626l2.1-.136,2.9,4.246V5.421L9.69,5.34a.466.466,0,0,1,.454-.544ZM1.369.6,9.463.032a2.191,2.191,0,0,1,1.874.408l2.584,1.742c.426.3.568.381.568.708v9.554c0,.6-.227.953-1.022,1.007L4.067,14a1.2,1.2,0,0,1-1.193-.436l-1.9-2.368a1.788,1.788,0,0,1-.482-1.143V1.556A.866.866,0,0,1,1.369.6Z'
      fill={fill}
    />
  </svg>
)

export default NotionIcon
